var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input-icon',{attrs:{"icon":{ name: 'search' },"id":"search","name":"search","type":"text","label":"Search:"},on:{"input":_vm.debounceSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }